'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var SpinningInner = require('./SpinningInner.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Spin = ({
  spinning = true,
  children,
  style
}) => {
  if (!spinning)
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children
    });
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(NestedSpinning, {
        children: /* @__PURE__ */ jsxRuntime.jsx(StyledSpinning, {
          children: /* @__PURE__ */ jsxRuntime.jsx(SpinningInner.StyledSpinningInner, {})
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsx(StyledContainer, {
        style,
        children
      })
    ]
  });
};
const NestedSpinning = styled__default["default"].div`
  position: relative;
`;
const StyledSpinning = styled__default["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: block;
  width: 100%;
  height: 100%;
  max-height: 400px;
  top: 40px;
  left: calc(50% - 40px);
`;
const StyledContainer = styled__default["default"].div`
  clear: both;
  opacity: 0.5;
  user-select: none;
  pointer-events: none;
`;

exports.Spin = Spin;
